
import { Routes, Route } from "react-router-dom";
import DoctorRegistration from '../doctors/registation'

const DoctorRoutes = () => {
    return(
        <Routes>
            <Route path="/" element={<DoctorRegistration />} />
        </Routes>
    );
}
export default DoctorRoutes;